// extracted by mini-css-extract-plugin
module.exports = {"sec":"AcceptInvite_sec__oIItW","open":"AcceptInvite_open__ldVsx","container":"AcceptInvite_container__Kw5_Z","text":"AcceptInvite_text__OZmhx"};